import { useRouter } from 'next/router';
import { globalDataStore } from '@/dashboard/store/globalDataStore';
import qs from 'qs';

export const useProjectNavigate = () => {
  const router = useRouter();
  const {
    state: { queryParams },
  } = globalDataStore();

  const push = (data: { path: string; replace?: boolean }, params?: any) => {
    if (!data?.path) return;
    let url = data.path;

    const combineParams = {
      ...queryParams,
      ...params,
    };
    if (combineParams) {
      const hasQuery = data?.path?.includes('?');
      let urlParamsStr = qs.stringify(combineParams);
      if (hasQuery) {
        const separator = url.endsWith('?') ? '' : '&';
        url = `${url}${separator}${urlParamsStr}`;
      } else {
        url = `${url}?${urlParamsStr}`;
      }
    }

    if (data?.replace) {
      router.replace(url);
    } else {
      router.push(url);
    }
  };

  const pop = () => {
    router.back();
  };

  return { push, pop };
};
